import {
  DataCollectionSource,
  FiltersDefinition,
  GroupingDefinition,
  ItemActionsDefinition,
  NavigationFiltersDefinition,
  OneDataCollection,
  RecordType,
  SortingsDefinition,
  SummariesDefinition,
} from '@factorialco/f0-react/dist/experimental'
import { File, Link } from '@factorialco/f0-react/icons/app'

import { formatFileSize } from 'modules/trainings/components/Files/utils'
import { DEFAULT_DATA_COLLECTION_STORAGE } from 'modules/trainings/lib/collections'

type FileMaterialItem = {
  filename: string
  title?: string | null
  contentType?: string
  size: number
  id: number
  type: 'training' | 'trainingClass' | 'membership'
} & RecordType

type LinkMaterialItem = {
  title: string
  url: string
  type: 'link'
  id: number
}

export type MaterialItem = FileMaterialItem | LinkMaterialItem

export const getSortableTitle = (item: MaterialItem): string => {
  if (item.type === 'link') {
    return item.title
  }
  return item.title || item.filename
}

export const MaterialsList = ({
  source,
  emptyStates,
}: {
  source: DataCollectionSource<
    MaterialItem,
    FiltersDefinition,
    SortingsDefinition,
    SummariesDefinition,
    ItemActionsDefinition<MaterialItem>,
    NavigationFiltersDefinition,
    GroupingDefinition<MaterialItem>
  >
  emptyStates?: {
    'no-data': {
      title: string
      description: string
    }
  }
}) => {
  return (
    <OneDataCollection
      id="trainings/materials/v1"
      storage={DEFAULT_DATA_COLLECTION_STORAGE}
      emptyStates={emptyStates}
      source={source}
      visualizations={[
        {
          type: 'card',
          options: {
            title: (item: MaterialItem) => {
              switch (item.type) {
                case 'link': {
                  return item.title
                }
                default: {
                  return item.title || item.filename
                }
              }
            },
            description: (item: MaterialItem) => {
              if (item.type === 'link') return ''
              return formatFileSize(item.size || 0)
            },
            cardProperties: [
              {
                label: '',
                icon: Link,
                render: (item: MaterialItem) => {
                  if (item.type !== 'link') return
                  return {
                    type: 'text' as const,
                    value: item.url,
                  }
                },
              },
              {
                label: '',
                icon: File,
                render: (item: MaterialItem) => {
                  // TODO: this should be a check for type file, but
                  // for some god forsaken reason we're getting
                  //  type === 'training' instead of 'file'
                  if (item.type === 'link') return
                  return {
                    type: 'file' as const,
                    value: {
                      name: item.filename,
                      type: item.contentType,
                    },
                  }
                },
              },
            ],
          },
        },
      ]}
    />
  )
}
